import { map } from 'ramda';

export const mimeTypesToNames: (mimeTypes: string[]) => string[] = map(
  (mimeType) => mimeTypeName[mimeType] || mimeType,
);

const mimeTypeName = {
  'video/mpeg': 'MPEG',
  'video/mp4': 'MP4',
  'video/webm': 'WebM',
  'video/quicktime': 'QuickTime',
  'video/ogg': 'Ogg',
  'video/dvd': 'DVD',
  'video/x-m4v': 'M4V',
  'video/3gpp': '3GPP',
  'video/x-matroska': 'Matroska',
  'video/x-msvideo': 'AVI',
  'video/divx': 'DivX',
  'video/x-xvid': 'Xvid',
  'application/mxf': 'MXF',
  'video/x-ms-wmv': 'WMV',
  'video/x-flv': 'FLV',
  'video/mp2t': 'MPEG-2',
  'image/bmp': 'BMP',
  'image/gif': 'GIF',
  'image/heic': 'HEIC',
  'image/heif': 'HEIF',
  'image/tiff': 'TIFF',
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/webp': 'WebP',
  'image/jp2': 'JPEG',
  'image/x-canon-cr2': 'CR2',
  'image/x-nikon-nef': 'NEF',
  'image/x-sony-arw': 'ARW',
  'image/x-adobe-dng': 'DNG',
  'audio/mpeg': 'MPEG',
  'audio/wav': 'WAV',
  'audio/flac': 'FLAC',
  'audio/mp4': 'MP4',
  'audio/x-ms-wma': 'WMA',
  'audio/aac': 'AAC',
  'audio/aiff': 'AIFF',
  'application/gzip': 'GZIP',
  'application/java-archive': 'Java Archive',
  'application/vnd.rar': 'RAR',
  'application/x-7z-compressed': '7-Zip',
  'application/x-tar': 'TAR',
  'application/x-webarchive': 'Web',
  'application/zip': 'ZIP',
  'application/pdf': 'PDF',
  'image/svg+xml': 'SVG',
  'image/x-icon': 'Icon',
  'image/vnd.microsoft.icon': 'Icon',
  'model/gltf-binary': 'GLB',
  'application/msword': 'Word',
  'application/vnd.ms-excel': 'Excel',
  'application/vnd.ms-powerpoint': 'PowerPoint',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word',
  'application/vnd.ms-word.document.macroEnabled.12': 'Word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'Word',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'Excel',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PowerPoint',
  'application/vnd.openxmlformats-officedocument.presentationml.template': 'PowerPoint',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'PowerPoint',
};
